import React from 'react';
const { useState, useEffect } = React;

// A clear way back after opening something from another screen (Directorio → a client's file → one of its processes →
// back to the file → back to the Directorio; Diagnósticos → a diagnostic; Actividades y entregas → a process…). A small
// stack in this browser tab only (sessionStorage): nothing is saved by leaving, the screen it returns to keeps its own
// search, filter and place, and choosing an entry of the menu starts over.
export const RETURN_KEY = 'oike_return_to';
const read = () => { try { const v = JSON.parse(sessionStorage.getItem(RETURN_KEY) || '[]'); return Array.isArray(v) ? v : v && v.detail ? [v] : []; } catch { return []; } };
const write = (list) => { try { sessionStorage.setItem(RETURN_KEY, JSON.stringify(list.slice(-6))); } catch { /* the way back is a convenience */ } window.dispatchEvent(new Event('oike:returnChanged')); };
const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);

/** Remembers where to go back: `label` («Diagnósticos», «el Directorio»…), `detail` (an oike:navigate detail), `on` (pages where the bar shows). */
export function setReturn(label, detail, on) {
  write([...read().filter(e => !same(e.detail, detail)), { label: String(label).slice(0, 80), detail, on }]);
}
/** Arriving at a screen by itself (the list, the file): its own way back is no longer needed. */
export function clearReturnTo(page) { write(read().filter(e => e.detail?.page !== page)); }
/** A menu entry starts a new way: every way back is forgotten. */
export function clearAllReturns() { write([]); }

export default function ReturnToList({ page }) {
  const [list, setList] = useState(read);
  useEffect(() => {
    const r = () => setList(read());
    r();
    window.addEventListener('oike:returnChanged', r);
    return () => window.removeEventListener('oike:returnChanged', r);
  }, [page]);
  const idx = list.map((e, i) => ((e.on || []).includes(page) ? i : -1)).filter(i => i >= 0).pop();
  if (idx === undefined) return null;
  const back = list[idx];
  const go = () => { write(list.slice(0, idx)); window.dispatchEvent(new CustomEvent('oike:navigate', { detail: back.detail })); };
  const hide = () => write(list.filter((_, i) => i !== idx));
  return (
    <div role="region" aria-label={`Volver a ${back.label}`} style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', background: 'var(--teal-dim, rgba(91,191,181,0.15))', border: '1px solid var(--globant-green)', borderRadius: 10, padding: '8px 12px', margin: '0 0 10px', fontSize: 13 }}>
      <button type="button" className="action-btn btn-primary" style={{ fontSize: 12 }} onClick={go}>← Volver a {back.label}</button>
      <button type="button" className="action-btn" style={{ fontSize: 11 }} onClick={hide}>Ocultar</button>
    </div>
  );
}
